import React, { useEffect, useState } from 'react';
import cn from "classnames";
import ReactTooltip from "react-tooltip";
import {TableHeader} from "./TableHeader";
import {isEmpty} from "lodash";
import {ItemRow} from "./ItemRow";
import Loader from "../../../components/utils/Loader";
import Select from "react-select";
import {styles} from "../../../containers/goods/styles";
import {useDispatch, useSelector} from "react-redux";
import {reasonsLoadingSelector, reasonsSelector} from "../../../selectors/forms";
import DateInput from '../../../components/utils/DateInput';
import ReactPaginate from 'react-paginate';
import { fetchWriteoffs, setWriteoffsFilters, setWriteoffsPaging } from '../../../action/writeoff';
import moment from 'moment';
import { fetchFilials } from '../../../action/handbook';
import { fetchWriteOffFormReasons } from '../../../action/reasons';
import PointsSelect from '../../../components/utils/PointsSelect';

const WriteOffList = () => {
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointsLoading = useSelector(state => state.loaders.filials);
    const UImobile = useSelector(state => state.UImobile);
    const filters = useSelector(state => state.writeoffs.filters);
    const paging = useSelector(state => state.writeoffs.paging);
    const count = useSelector(state => state.writeoffs.count);
    const writeoffs = useSelector(state => state.writeoffs.list);
    const loadingWriteoff = useSelector(state => state.loaders.writeoffs);
    const reasons = useSelector(reasonsSelector);
    const reasonsLoading  = useSelector(reasonsLoadingSelector);
    const loading = loadingWriteoff || pointsLoading || reasonsLoading;

    const [currentPage, setCurrentPage] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

    const dispatch = useDispatch();

    const onSearch = () => {
        dispatch(setWriteoffsPaging({ ...paging, start: 0 }));
        setCurrentPage(0);
        dispatch(fetchWriteoffs());
    }

    useEffect(() => {
        if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
        if (isEmpty(reasons)) dispatch(fetchWriteOffFormReasons())
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => onSearch(), []);

    const setFilters = (field) => (data) => {
        const updated = { ...filters };

        let value = null;
        if (data) {
            if (data.value) {
                value = data.value;
            } else {
                value = data;
            }
        }
        updated[field] = value;

        if (value && field === 'startDate') {
            const startDate = moment(value);
            const endDate = moment(filters.endDate);
            if (endDate.isBefore(startDate, 'day')) updated.endDate = startDate.toDate();
            else if (startDate.isBefore(endDate.clone().subtract(1, 'month'), 'day')) updated.endDate = startDate.clone().add(1, 'month').toDate();
        }
        if (value && field === 'endDate') {
            const endDate = moment(value);
            const startDate = moment(filters.startDate);
            const maxDate = startDate.clone().add(1, 'month');
            if (startDate.isAfter(endDate)) updated.startDate = endDate.toDate();
            else if (endDate.isAfter(maxDate)) updated.startDate = endDate.clone().subtract(1, 'month').toDate();
        }

        if(value === null) updated[field] = null;
        dispatch(setWriteoffsFilters(updated));
        onSearch();
    }

    const reasonOptions = reasons.map((reason) => ({
        value: reason.id,
        label: reason.name,
    }));
    
    useEffect(() => {        
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
        let nextStart =  data.selected * paging.limit;
        const updatedPaging = {...paging, start: nextStart};
        dispatch(setWriteoffsPaging(updatedPaging));
        dispatch(fetchWriteoffs());
    };

    const setPageLimit = (e) => {
        e.preventDefault();
        const updatedPaging = { start: 0, limit: e.target.value};
        setCurrentPage(0);
        dispatch(setWriteoffsPaging(updatedPaging));
        dispatch(fetchWriteoffs());
    }

    const chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;
        if (userDisplayWidth < 400) return 1;
        if (userDisplayWidth < 550) return 2;
        if (userDisplayWidth < 850) return 3;
        if (userDisplayWidth < 1250) return 5;
        return 8;
    }

    const chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 5;
    }

    const renderPagination = () => {
        const pages = Math.ceil(+count / +paging.limit);

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded order_table">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={chekMarginPagesDisplayed()}
                    pageRangeDisplayed={chekPageRangeDisplayed()}
                    forcePage={currentPage}
                    onPageChange={handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={setPageLimit} value={paging.limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            paging.start + paging.limit >= count ? (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+count} из {count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+paging.start + +paging.limit} из {count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{padding: 0}}>
                <div className="kt-portlet__body">
                    <div className='kt-form kt-form--label-right kt-margin-b-10 d-flex' style={{ gap: '10px' }}>
                    {!isMobile ? (
                            <>
                            <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                                <div className="kt-subheader__group" id="kt_subheader_search">
                                <span className="kt-subheader__desc" id="kt_subheader_total">
                                    <div>
                                        <div className="dateBlock input">
                                        <DateInput
                                        disabled={loading}
                                        showPopperArrow={false}
                                        placeholderText="Дата начала"
                                        selected={filters.startDate}
                                        onChange={setFilters('startDate')}
                                        dateFormat="dd.MM.yyyy"
                                        showTimeSelect={false}
                                        />
                                        <div>-</div>
                                        <DateInput
                                        disabled={loading}
                                        showPopperArrow={false}
                                        placeholderText="Дата окончания"
                                        selected={filters.endDate}
                                        onChange={setFilters('endDate')}
                                        dateFormat="dd.MM.yyyy"
                                        showTimeSelect={false}
                                        />
                                        </div>
                                    </div>
                                </span>
                                </div>
                                <PointsSelect disabled={loading} width={200} placeholder='Все филиалы' values={filters.points} setData={setFilters('points')}/>
                                <div style={{ width: 200 }}>
                                    <Select
                                        options={reasonOptions}
                                        placeholder="Все причины"
                                        isClearable={true}
                                        isLoading={loading}
                                        onChange={setFilters('writeoffreason')}
                                    />
                                </div>
                            </>
                        ) : UImobile.openFilters && (
                            <div key={window.innerWidth}>
                                <div className="mb-3 mobile-filter-item">
                                    <label className="d-block">Филиалы</label>
                                    <PointsSelect disabled={loading} width={200} placeholder='Все филиалы' values={filters.points} setData={setFilters('points')}/>
                                </div>
                                <div className="mb-3 mobile-filter-item">
                                    <label className="d-block">Даты</label>
                                    <div className="dateBlock input">
                                        <DateInput
                                            disabled={loading}
                                            showPopperArrow={false}
                                            placeholderText="Дата"
                                            selected={filters.startDate}
                                            onChange={setFilters('startDate')}
                                            dateFormat="dd.MM.yyyy"
                                            showTimeSelect={false}
                                        />
                                        <div>-</div>
                                        <DateInput
                                            disabled={loading}
                                            showPopperArrow={false}
                                            placeholderText="Дата"
                                            selected={filters.endDate}
                                            onChange={setFilters('endDate')}
                                            dateFormat="dd.MM.yyyy"
                                            showTimeSelect={false}
                                        />
                                    </div>
                                </div>
                                <div className="mb-3 mobile-filter-item">
                                    <label className="d-block">Причина</label>
                                    <Select
                                        options={reasonOptions}
                                        placeholder="Все причины"
                                        isClearable={true}
                                        isLoading={loading}
                                        onChange={setFilters('writeoffreason')}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div
                        style={{position: 'relative', marginBottom: 0}}
                        className={cn(
                            'kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded',
                            {'kt-datatable--error': !loading && isEmpty(writeoffs)}
                        )}
                    >
                        {loading && (
                            <div style={styles.tableLoading}>
                                <Loader text="Загружаем списания..."/>
                            </div>
                        )}
                        <table className="kt-datatable__table" style={{minHeight: '700px'}}>
                            {window.innerWidth > 730 && <TableHeader UImobile={UImobile}/>}
                            <tbody className="kt-datatable__body">
                            {
                                loading ? null : isEmpty(writeoffs) ? (
                                        <tr>
                                            <td colSpan={4}>
                                              <span className="kt-datatable--error">
                                                  Списаний нет
                                              </span>
                                            </td>
                                        </tr>
                                    )
                                    : (
                                        writeoffs.map((item) => {
                                            if (item.point && !item.point.id) item.point = points.find((point) => point.id === item.point);
                                            let point = item.point;
                                            if (point && !point.id) point = points.find((el) => el.id === point);
                                            if (point && point.id && (!point.city || !point.city.id)) point = points.find((el) => el.id === point.id);
                                            item.point = point;
                                            if (item.writeoffreason && !item.writeoffreason.id) item.writeoffreason = reasons.find((reason) => reason.id === item.writeoffreason);
                                            return <ItemRow key={item.id} item={item}/>
                                        })
                                    )
                            }
                            </tbody>
                        </table>
                        {renderPagination()}
                </div>
            </div>
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
};

export default WriteOffList;
